import React, { useState, useContext, useEffect } from 'react';
import { Redirect } from 'react-router';
//import { AppDataContext } from "./AppDataContext"
import useNetwork from '../../useNetwork';
import { Loader } from '../Loader';
import { Helmet } from "react-helmet";

export function Notifications(props) { 

   //const context = useContext(AppDataContext);
    const { loading, networkError, netRequest, netRenderError } = useNetwork(false);
    const [message, setMessage] = useState(null);
    const [isError, setIsError] = useState(false);


    //if (networkError) {
    //    //return netRenderError();
    //    if (networkError === "Unauthorized") {
    //        return <Redirect to="/login" />;
    //    }
    //    return <Redirect to="/error" status={networkError} />

    //}
    //if (loading)
    //    return <></>

    return (
        <>
            <Helmet>
                <title>Notifications</title>
            </Helmet>
            <div class="row mt-3">
                <div class="col-12 mb-1">
                    <h4 class="auction-grid-header">
                        Notifications
                        <div class="divider mt-2"></div>
                    </h4>
                    {
                        message ? <div className={"alert " + (isError ? "alert-danger" : "alert-success")} >{message}</div> : <div class="alert">&nbsp;</div>
                    }
                </div>

                


            </div>

            <Loader loading={loading} />


        </>
    );

}
